<template>
  <div>
  <b-navbar toggleable="sm" type="light" variant="light">
    <b-navbar-brand href="https://instantlyart.com">INSTANTLY.ART</b-navbar-brand>

    <svg v-if="isMobileWidth" @click="$emit('open-cart')" aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 37 40"><path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"></path></svg>
    <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

    <b-collapse id="nav-text-collapse" is-nav style="font-size:14px;">
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown text="Custom Designers" right>
          <b-dropdown-item href="https://instantlyart.com/map-designer?ref=menu">City Map Designer</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/waveform-designer?ref=menu">Soundwave Designer</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="City Maps" right>
          <b-dropdown-item href="https://instantlyart.com/collections/best-sellers">Best Sellers</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/north-america">North America</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/central-america">Central America</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/south-america">South America</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/western-europe">Western Europe</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/central-europe">Central Europe</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/eastern-europe">Eastern Europe</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/mediterranean">Mediterranean</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/africa">Africa</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/asia">Asia</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/australia">Australia</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Soundwaves" right>
          <b-dropdown-item href="https://instantlyart.com/collections/quotes">Quotes</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/sayings">Sayings</b-dropdown-item>
          <b-dropdown-item href="https://instantlyart.com/collections/songs">Songs</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item href="https://instantlyart.com/collections/state-poster-prints">State Posters</b-nav-item>
        <svg v-if="!isMobileWidth" @click="$emit('open-cart')" aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart-full" viewBox="0 0 37 40"><path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"></path></svg>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data() {
    return {
      ui: {
        windowWidth: 350
      }
    }
  },
  computed: {
    isMobileWidth: function () {
      return this.ui.windowWidth <= 600
    }
  },
  created () {
    var self = this
    self.ui.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      self.ui.windowWidth = window.innerWidth
    })
  }
}
</script>
<style>
@import 'https://fonts.googleapis.com/css?family=Crushed';
nav {
  background: #FFFFFF!important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  border-bottom:0px!important;
  z-index: 104;
  width: 100%;
  margin-bottom: 56px;
  position:absolute!important;
}
.navbar-brand {
  font-family: 'Crushed', cursive!important;
  font-size:1.2em;
  color:black;
}
.dropdown-menu {
  background:#FFFFFF;
  margin-top:-5px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  border-radius: 0px;
  border: none;
}

.icon-cart {
  height: 23px;
  width: 22px;
  margin-right: 15px;
  margin-left: auto;
  position: relative;
  fill: #7c7c7d;
  cursor: pointer;
}
.icon-cart-full {
  height: 23px;
  width: 22px;
  fill: #7c7c7d;
  cursor: pointer;
  margin-top: 5px;
  margin-left: 10px;
}
.slideout-panel .slideout-panel-bg {
  z-index: 107!important;
}
.slideout-panel .slideout-wrapper .slideout {
  z-index: 108!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue